import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Csv = props => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 27 33"
      style={{ width: "50", height: "50" }}
    >
      <svg
        width="87"
        height="93"
        viewBox="0 0 87 93"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.3">
          <path
            opacity="0.3"
            d="M18.8605 6.65051C18.1222 6.64979 17.4144 6.3562 16.8923 5.83417C16.3703 5.31214 16.0767 4.60433 16.076 3.86607V2.50925e-07H3.63518C3.15787 -0.000177123 2.68517 0.0936834 2.24414 0.27622C1.80311 0.458757 1.40236 0.726391 1.06479 1.06384C0.727217 1.40129 0.459431 1.80194 0.276731 2.2429C0.0940303 2.68386 -3.29568e-08 3.15649 0 3.63381V25.5393C-3.29568e-08 26.0166 0.0940303 26.4892 0.276731 26.9302C0.459431 27.3712 0.727217 27.7718 1.06479 28.1093C1.40236 28.4467 1.80311 28.7143 2.24414 28.8969C2.68517 29.0794 3.15787 29.1733 3.63518 29.1731H18.5701C19.5339 29.1731 20.4581 28.7903 21.1396 28.1088C21.8211 27.4273 22.2039 26.503 22.2039 25.5393V6.65051H18.8605Z"
            fill="#00C650"
          />
        </g>
        <path
          d="M22.2752 6.65964H18.9239C18.1839 6.65893 17.4744 6.36692 16.9512 5.8477C16.4279 5.32848 16.1336 4.62446 16.1329 3.89017V0.0448914L22.2752 6.65964Z"
          fill="#00C650"
        />
        <path
          d="M24.8273 22.9603H7.91103C6.71107 22.9603 5.73831 23.9393 5.73831 25.147V30.2231C5.73831 31.4309 6.71107 32.4099 7.91103 32.4099H24.8273C26.0272 32.4099 27 31.4309 27 30.2231V25.147C27 23.9393 26.0272 22.9603 24.8273 22.9603Z"
          fill="#00C650"
        />
        <path
          d="M10.9356 28.8663V29.8113H9.75439V28.8663H10.9356Z"
          fill="white"
        />
        <path
          d="M14.5135 25.9839C14.8651 26.2697 15.104 26.6712 15.1879 27.117H14.1214C14.0497 26.9323 13.9236 26.7738 13.7598 26.6627C13.5878 26.5496 13.3855 26.4918 13.1799 26.4968C13.0441 26.4925 12.9091 26.5195 12.7854 26.5758C12.6617 26.6321 12.5526 26.7162 12.4665 26.8215C12.29 27.0757 12.1954 27.378 12.1954 27.6877C12.1954 27.9974 12.29 28.2997 12.4665 28.5539C12.5531 28.6585 12.6623 28.7419 12.7859 28.7977C12.9096 28.8535 13.0444 28.8802 13.1799 28.8758C13.3855 28.8808 13.5878 28.823 13.7598 28.7099C13.9227 28.6003 14.0487 28.4439 14.1214 28.2612H15.1879C15.1022 28.7055 14.8635 29.1055 14.5135 29.3914C14.137 29.6811 13.6709 29.8291 13.1966 29.8095C12.8238 29.8177 12.4558 29.7248 12.1314 29.5406C11.827 29.3642 11.5805 29.1026 11.4222 28.788C11.2574 28.4437 11.1718 28.0668 11.1718 27.6849C11.1718 27.3031 11.2574 26.9261 11.4222 26.5818C11.5805 26.2672 11.827 26.0056 12.1314 25.8293C12.4558 25.6451 12.8238 25.5521 13.1966 25.5603C13.6715 25.5429 14.1374 25.6928 14.5135 25.9839Z"
          fill="white"
        />
        <path
          d="M18.5591 29.2048C18.4413 29.3959 18.272 29.549 18.0712 29.646C17.8275 29.7617 17.5604 29.8178 17.2914 29.8097C16.8856 29.8264 16.4858 29.7069 16.1539 29.4698C16.0072 29.3585 15.8871 29.2151 15.8026 29.0503C15.7182 28.8855 15.6715 28.7036 15.666 28.518H16.7227C16.7296 28.6576 16.7884 28.7894 16.8871 28.8871C16.9854 28.98 17.1159 29.0299 17.2503 29.0258C17.3605 29.0315 17.4686 28.9937 17.5518 28.9204C17.5884 28.8845 17.6171 28.8413 17.6362 28.7935C17.6553 28.7457 17.6644 28.6944 17.6628 28.6429C17.6641 28.5942 17.6557 28.5457 17.6381 28.5004C17.6204 28.4551 17.5939 28.4139 17.56 28.3793C17.4883 28.3049 17.4025 28.246 17.3079 28.2058C17.2078 28.1601 17.068 28.1073 16.8967 28.0435C16.6797 27.9711 16.4677 27.8839 16.2622 27.7827C16.093 27.6941 15.9476 27.565 15.8387 27.4067C15.7208 27.2123 15.659 26.9884 15.6605 26.7603C15.6619 26.5322 15.7265 26.3091 15.847 26.1163C15.9758 25.9311 16.154 25.7867 16.3609 25.7001C16.5991 25.6021 16.8548 25.5549 17.1119 25.5614C17.5012 25.5403 17.8858 25.6565 18.2 25.8902C18.3323 25.9989 18.4409 26.1342 18.519 26.2875C18.5971 26.4408 18.6429 26.6088 18.6537 26.7809H17.5806C17.5683 26.6586 17.5162 26.544 17.4326 26.4549C17.3896 26.4139 17.339 26.3821 17.2837 26.3614C17.2283 26.3407 17.1694 26.3314 17.1105 26.3342C17.0109 26.3309 16.9135 26.3645 16.8364 26.4285C16.7989 26.4635 16.7697 26.5067 16.7509 26.5547C16.7322 26.6028 16.7244 26.6545 16.7282 26.706C16.7264 26.7988 16.7609 26.8885 16.8241 26.9557C16.8923 27.0278 16.9744 27.085 17.0653 27.1236C17.1626 27.1666 17.301 27.2221 17.4764 27.2887C17.6975 27.3608 17.9128 27.4499 18.1206 27.5551C18.2915 27.6478 18.4384 27.7799 18.5495 27.9408C18.6777 28.1348 18.7411 28.3653 18.7304 28.5985C18.7301 28.8128 18.6708 29.0228 18.5591 29.2048Z"
          fill="white"
        />
        <path
          d="M20.0001 25.7952L20.9752 28.8173L21.9516 25.7952H22.9839L21.5959 29.8113H20.3491L18.9678 25.7952H20.0001Z"
          fill="white"
        />
        <path
          d="M15.9985 20.3616H6.10895C5.25281 20.3616 4.5571 19.4996 4.5571 18.4386V11.18C4.5571 10.1203 5.25281 9.25829 6.10895 9.25829H15.9985C16.8546 9.25829 17.5504 10.1203 17.5504 11.18V18.4345C17.5504 19.4956 16.8546 20.3616 15.9985 20.3616ZM6.10895 10.2457C5.69099 10.2457 5.35125 10.6658 5.35125 11.1841V18.4386C5.35125 18.9568 5.69099 19.3783 6.10895 19.3783H15.9985C16.4165 19.3783 16.7576 18.9568 16.7576 18.4386V11.18C16.7576 10.6617 16.4165 10.2416 15.9985 10.2416L6.10895 10.2457Z"
          fill="#00C650"
        />
        <path
          d="M17.3141 16.1093H5.02959V17.0542H17.3141V16.1093Z"
          fill="#00C650"
        />
        <path
          d="M17.3141 12.8019H5.02959V13.7469H17.3141V12.8019Z"
          fill="#00C650"
        />
        <path
          d="M14.0067 9.96701H13.0618V19.8891H14.0067V9.96701Z"
          fill="#00C650"
        />
        <path
          d="M9.04567 9.96701H8.10071V19.8891H9.04567V9.96701Z"
          fill="#00C650"
        />
      </svg>
    </SvgIcon>
  );
};

export default SvgI24Csv;
